/**
 * @author Vijay
 */
import service from '../Common/'
import constants from '../../../settings/shared/constants'


function _constructHeader() {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {
        'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken
    }
    return headers;
}

function getMenuList() {
    return service({
        url: constants.api.setting.getMenuList,
        method: 'GET',
        headers: _constructHeader(),
        data: {}
    });
}

function updateMenuList(updateData) {
    return service({
        url: constants.api.setting.updateMenu,
        method: 'PUT',
        headers: _constructHeader(),
        data: updateData
    });
}

function getMenus() {
    return service({
        url: constants.api.setting.getMenuOption,
        method: 'GET',
        headers: _constructHeader(),
        data: {}
    });
}

function getMenuProps(type) {
    return service({
        url: constants.api.setting.getProps + type,
        method: 'GET',
        headers: _constructHeader(),
        data: ''
    });
}


function saveCustomMenu(customData) {
    return service({
        url: constants.api.widgets.saveCustomMenu,
        method: 'POST',
        headers: _constructHeader(),
        data: customData
    })
}

function getDashboardMenuName(name) {
    return service({
        url: constants.api.widgets.getMenuDashboard + "/" + name,
        method: 'GET',
        headers: _constructHeader(),
        data: {}
    });
}

function updateMenuNameById(dashboardId, menuName) {
    return service({
        url: constants.api.widgets.updateMenuName + "/" + dashboardId + "/" + menuName,
        method: 'PUT',
        headers: _constructHeader(),
        data: {}
    });
}

function addWidgetByDashboard(wData) {
    return service({
        url: constants.api.widgets.addWidget,
        method: 'POST',
        headers: _constructHeader(),
        data: wData
    })
}

function getDashboardInfo(dashboardId) {
    return service({
        url: constants.api.widgets.getDashboardInfo + "/" + dashboardId,
        method: 'GET',
        headers: _constructHeader(),
        data: {}
    });
}

function updateWidgetById(widgetId, updateData) {
    return service({
        url: constants.api.widgets.updateWidgetById + "/" + widgetId,
        method: 'PUT',
        headers: _constructHeader(),
        data: updateData
    });
}

function removeWidgetById(widgetId) {
    return service({
        url: constants.api.widgets.removeWidgetById + "/" + widgetId,
        method: 'DELETE',
        headers: _constructHeader(),
        data: {}
    });
}

function removeDashboardByName(menuName) {
    return service({
        url: constants.api.widgets.removeDashboardByName + "/" + menuName,
        method: 'DELETE',
        headers: _constructHeader(),
        data: {}
    });
}

function getCustomMenus() {
    return service({
        url: constants.api.widgets.getMenuById,
        method: 'GET',
        headers: _constructHeader(),
        data: {}
    });
}


//To export setting function
const SettingsService = {
    getMenuList, updateMenuList, getMenus, getMenuProps, saveCustomMenu, getDashboardMenuName, addWidgetByDashboard,
    getDashboardInfo, updateWidgetById, removeWidgetById, getCustomMenus, removeDashboardByName, updateMenuNameById
}

export default SettingsService;
